/* eslint-disable no-throw-literal */
import normalizeById from 'app/utils/NormalizeById';
import ApiService from 'app/services/ApiService';

export const TEST_SUCCESS = 'TEST_SUCCESS';
export const TEST_BEGIN = 'TEST_BEGIN';
export const TEST_FAILURE = 'TEST_FAILURE';
export const CLEAR_TEST = 'CLEAR_TEST';

export const TEST_QUIESTION_SUCCESS = 'TEST_QUIESTION_SUCCESS';
export const TEST_QUIESTION_BEGIN = 'TEST_QUIESTION_BEGIN';
export const TEST_QUIESTION_FAILURE = 'TEST_QUIESTION_FAILURE';
export const CLEAR_TEST_QUIESTION = 'CLEAR_TEST_QUIESTION';

export const TEST_FILTER_SUCCESS = 'TEST_FILTER_SUCCESS';
export const TEST_FILTER_BEGIN = 'TEST_FILTER_BEGIN';
export const TEST_FILTER_FAILURE = 'TEST_FILTER_FAILURE';
export const CLEAR_TEST_FILTER = 'CLEAR_TEST_FILTER';

export const EXPORT_SUCCESS = 'EXPORT_SUCCESS';
export const EXPORT_BEGIN = 'EXPORT_BEGIN';
export const EXPORT_FAILURE = 'EXPORT_FAILURE';
export const CLEAR_EXPORT = 'CLEAR_EXPORT';

export function fetchTest(params = {}) {
	return async dispatch => {
		dispatch(testBegin());
		await ApiService.getTests(params)
			.then(
				result => {
					dispatch(addTest(result));
				},
				error => {
					dispatch(testError());
					throw ({ error: error, message: 'An error ocurred' });
				}
			)
	};
}

export function fetchQuestionTestById(data) {
	return async dispatch => {
		dispatch(clearTestQuestion())
		dispatch(testQuestionBegin());
		await ApiService.getTestQuestionsbyId(data)
			.then(
				result => {
					let normalized = normalizeById(result.Data, 'idTest');
					dispatch(addTestQuestion(normalized));
					return normalized;
				},
				error => {
					dispatch(testQuestionError());
					throw ({ error: error, message: 'An error ocurred' });
				}
			)
	};
}

export function fetchTestFilters(SubDirection, EmployeeId) {
	return async dispatch => {
		dispatch(testFilterBegin());
		await ApiService.getTestFilter(SubDirection, EmployeeId)
			.then(
				result => {
					dispatch(addTestFilter(result));
				},
				error => {
					dispatch(testFilterError());
					throw ({ error: error, message: 'An error ocurred' });
				}
			)
	};
}

export function fetchExportToExcel(data) {
	return async dispatch => {
		dispatch(clearExport())
		dispatch(exportBegin());
		await ApiService.getExportToExcel(data)
			.then(
				result => {
					let normalized = normalizeById(result.Data, 'idTest');
					dispatch(exportSuccess(normalized));
					return normalized;
				},
				error => {
					dispatch(exportError());
					throw ({ error: error, message: 'An error ocurred' });
				}
			)
	};
}



export const testBegin = () => ({
	type: TEST_BEGIN,
});

export const addTest = data => ({
	type: TEST_SUCCESS,
	payload: { data }
})

export const testError = () => ({
	type: TEST_FAILURE,
})

export const clearTest = () => ({
	type: CLEAR_TEST,
})
//TEST QUIESTION BY ID
export const testQuestionBegin = () => ({
	type: TEST_QUIESTION_BEGIN,
});

export const addTestQuestion = data => ({
	type: TEST_QUIESTION_SUCCESS,
	payload: { data }
})

export const testQuestionError = () => ({
	type: TEST_QUIESTION_FAILURE,
})

export const clearTestQuestion = () => ({
	type: CLEAR_TEST_QUIESTION,
})

//TEST FILTERS
export const testFilterBegin = () => ({
	type: TEST_FILTER_BEGIN,
});

export const addTestFilter = data => ({
	type: TEST_FILTER_SUCCESS,
	payload: { data }
})

export const testFilterError = () => ({
	type: TEST_FILTER_FAILURE,
})

export const clearTestFilter = () => ({
	type: CLEAR_TEST_FILTER,
})

//EXPORT TEST
export const exportBegin = () => ({
	type: EXPORT_BEGIN,
});

export const exportSuccess = data => ({
	type: EXPORT_SUCCESS,
	payload: { data }
})

export const exportError = () => ({
	type: EXPORT_FAILURE,
})

export const clearExport = () => ({
	type: CLEAR_TEST_FILTER,
})

